import axios from 'axios';

class Currency {
  constructor() {
    this.url = 'https://open.er-api.com/v6/latest/USD';
  }

  async getCurrencies() {
    const response = await axios.get(this.url);
    const { TRY, EUR } = response.data.rates;

    return {
      dollarRate: TRY,
      euroRate: TRY / EUR
    };
  }
}

const currency = new Currency();
currency.getCurrencies().then(rates => {
  let isDollarVisible = true;

  const currencyWrapper = document.querySelector('.currency');
  currencyWrapper.innerHTML = `
    <div class="currency-item dollar">
    <i class="fa-solid fa-dollar-sign"></i> Dolar: ${rates.dollarRate.toFixed(2)}
       
    </div>
    <div class="currency-item euro">
    <i class="fa-solid fa-euro-sign"></i> Euro:  ${rates.euroRate.toFixed(2)}
    </div>
  `;

  const dollarElement = currencyWrapper.querySelector('.dollar');
  const euroElement = currencyWrapper.querySelector('.euro');

  setInterval(() => {
    if (isDollarVisible) {
      dollarElement.style.top = '-100%';
      euroElement.style.top = '0';
    } else {
      dollarElement.style.top = '0';
      euroElement.style.top = '100%';
    }
    isDollarVisible = !isDollarVisible;
  }, 5000);

}).catch(err => console.error(err));